/**
 * Mock Discord SDK for local browser development & tests. Returns a fake user/guild/channel
 * and fake auth WITHOUT any network call, so the whole UI + submission flow can be exercised
 * outside Discord. Gated by shouldUseMock() — it can NEVER be selected in production.
 * @see docs/01-activity-build-guide.md §7 (build a mock SDK)
 */
import type { ActivityContext, ActivitySdk } from './types.js';

const FAKE_USER = {
  id: '000000000000000001',
  username: 'yinzer_tester',
  globalName: 'Yinzer Tester',
  avatar: null,
};

export class MockActivitySdk implements ActivitySdk {
  readonly isMock = true;

  async connect(): Promise<ActivityContext> {
    // Simulate the async ready()/authenticate() handshake without touching the network.
    await Promise.resolve();
    return {
      user: { ...FAKE_USER },
      guildId: 'mock-guild',
      channelId: 'mock-channel',
      instanceId: 'mock-instance',
      // A mock session token the server accepts ONLY outside production (mirrors shouldUseMock()).
      accessToken: `mock.${FAKE_USER.id}`,
    };
  }
}
